<button [ngClass]="isOutline ? 'button-outline' : 'button-default'" class="button">{{ title }}</button>
